// import React from "react";
// import { toast } from "react-toastify";
// import { useNavigate, useParams } from "react-router-dom";

// import { useGetAdvertisementByIdQuery } from "../../../services/advertisement/advertisementApiSlice";
// import {
//   useDeleteAdvertisementMutation,
//   useUpdateAdvertisementMutation,
// } from "../../../services/advertisement/updateAdvertisementSlice";

// import { AdvertisementDetailForm } from "../../../component/advertisemnt/advertisementDetail/AdvertisementDetailForm";

// import classes from "./advertisementDetailPage.module.css";

// export const AdvertisementDetailPage = () => {
//   const { advertisementId } = useParams();
//   const navigate = useNavigate();

//   const { data: advertisementData, isLoading } = useGetAdvertisementByIdQuery(
//     advertisementId,
//     {
//       skip: !advertisementId,
//     }
//   );

//   const [updateAdvertisement, updateState] = useUpdateAdvertisementMutation();
//   const [deleteAdvertisement, deleteState] = useDeleteAdvertisementMutation();

//   const handleSubmit = async (formData) => {
//     try {
//       await updateAdvertisement({
//         id: advertisementId,
//         ...formData,
//       }).unwrap();

//       toast.success("Updated successfully!");
//       navigate("/advertisement");
//     } catch (err) {
//       toast.error("Update failed.");
//     }
//   };

//   const handleDelete = async () => {
//     if (!window.confirm("Delete this advertisement?")) return;

//     try {
//       const response = await deleteAdvertisement(advertisementId).unwrap();
//       toast.success(
//         response?.message?.diplayMessage || "Deleted successfully!"
//       );
//       navigate("/advertisement");
//     } catch (err) {
//       toast.error("Delete failed.");
//     }
//   };

//   if (isLoading) return null; // or loader

//   return (
//     <div className={classes.wrapper}>
//       <h2 className={classes.pageTitle}>Edit Advertisement</h2>

//       <AdvertisementDetailForm
//         initialValues={advertisementData}
//         onSubmit={handleSubmit}
//         onDelete={handleDelete}
//         isSubmitting={updateState.isLoading}
//         isDeleting={deleteState.isLoading}
//       />
//     </div>
//   );
// };
import React from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import { useGetAdvertisementByIdQuery } from "../../../services/advertisement/advertisementApiSlice";
import {
  useDeleteAdvertisementMutation,
  useUpdateAdvertisementMutation,
} from "../../../services/advertisement/updateAdvertisementSlice";

import { AdvertisementDetailForm } from "../../../component/advertisemnt/advertisementDetail/AdvertisementDetailForm";

import classes from "./advertisementDetailPage.module.css";

export const AdvertisementDetailPage = () => {
  // ✅ Always convert param to number
  const { advertisementId: adId } = useParams();
  const advertisementId = Number(adId);

  const navigate = useNavigate();

  const { data: advertisementData, isLoading } =
    useGetAdvertisementByIdQuery(advertisementId, {
      skip: !advertisementId,
    });

  const [updateAdvertisement, updateState] =
    useUpdateAdvertisementMutation();

  const [deleteAdvertisement, deleteState] =
    useDeleteAdvertisementMutation();

  /* ---------- Update ---------- */
  const handleSubmit = async (formData) => {
    try {
      await updateAdvertisement({
        id: advertisementId, // number ✅
        ...formData,
      }).unwrap();

      toast.success("Updated successfully!");
      navigate("/advertisement");
    } catch (err) {
      toast.error(err?.data?.message || "Update failed.");
    }
  };

  /* ---------- Delete ---------- */
  const handleDelete = async () => {
    if (!window.confirm("Delete this advertisement?")) return;

    try {
      const response = await deleteAdvertisement(advertisementId).unwrap();

      toast.success(
        response?.message?.diplayMessage || "Deleted successfully!"
      );

      navigate("/advertisement");
    } catch (err) {
      toast.error(err?.data?.message || "Delete failed.");
    }
  };

  if (isLoading) return null; // or <Loader />

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.pageTitle}>Edit Advertisement</h2>

      <AdvertisementDetailForm
        initialValues={advertisementData}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        isSubmitting={updateState.isLoading}
        isDeleting={deleteState.isLoading}
      />
    </div>
  );
};
